import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarHongkong2 extends Component {
  state = {
    registered: {},
  };

  seminar = "hongkong"; // ✅ unique identifier for this dojo

  componentDidMount() {
    this.fetchRegistered();
    // Optional auto-refresh every 10 seconds to sync across users
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Fetch current registration state
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Error fetching Hong Kong registration:", err);
    }
  };

  // ✅ Handle register/unregister
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // 🔐 Ask admin to unregister with PIN
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });
      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // ✅ Normal registration
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  // ✅ Render each participant
  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔵 default, 🔴 registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Hong Kong Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "Mr.Hitoshi Nagai")}
        <br />
        {this.renderParticipant(2, "Mr.Joshua Pang")}
        <br />
        {this.renderParticipant(3, "Mr.Wong Yu Hin")}
        <br />
        {this.renderParticipant(4, "Ms.Fiona Chong")}
        <br />
        {this.renderParticipant(5, "Ms.Hoi Kei Kwok")}
        <br />
        {this.renderParticipant(6, "Mr.Jonathan Cheung")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarHongkong2;
